import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getIndustriesPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/odvetvi",
		[Locale.en]: "/industries",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
